/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-curly-newline */
import { useState, useEffect, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import * as MUI from "@mui/material";
import { toast } from "react-toastify";
import { MenuLateralUsuario } from "../MenuLateralUsuario";

import apiUsuario from "../../../services/apiUsuario";

interface PropsParams {
  CPF: string;
}

interface IDProps {
  id_usuario: number;
}

interface IDAcessoProps {
  NOME: string;
  DESCRICAO: string;
}

export const TipoAcesso: React.FC = () => {
  const history = useHistory();
  const storedToken = sessionStorage.getItem("@webSDS:token");
  const [loading, setLoading] = useState(false);

  const [usuario, setUsuario] = useState<IDAcessoProps>({
    NOME: "",
    DESCRICAO: "",
  });
  // const [selectedOption,setSelectedOption] = useState("nome");
  const { CPF } = useParams<PropsParams>();
  const [ids, setIds] = useState<IDProps | null>(null);
  const [selectedOption, setSelectedOption] = useState("0");
  useEffect(() => {
    if (CPF !== undefined) {
      findUsuario(CPF);
    }
  }, [CPF]);

  async function findUsuario(CPF: string) {
    setLoading(true);
    const response = await apiUsuario.get(`/userBy/?cpf=${CPF}`, {
      headers: {
        Authorization: `Bearer ${storedToken}`,
      },
    });
    setUsuario(response.data[0]);
    setLoading(false);
    setIds(response.data[0].ID_USUARIO);
  }

  const handleSelectChange = (event: MUI.SelectChangeEvent) => {
    setSelectedOption(event.target.value);
  };

  const onSubmit = useCallback(
    async () => {
      setLoading(true);
      try {
        const response = await apiUsuario.put(
          `/user/updateTypeAccess/${ids}/${selectedOption}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );

        if (response.status === 200) {
          toast.success(`${response.data}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
          setTimeout(() => {
            history.goBack();
          }, 1500);
        }
        if (response.status === 401) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      } catch (error: any) {
        setLoading(false);
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      }
      setLoading(false);
      // history.goBack()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, ids, selectedOption, toast]
  );

  return (
    <MUI.Stack flexDirection="row" width="100%" height="80vh">
      <MenuLateralUsuario />

      {loading ? (
        <MUI.LinearProgress />
      ) : (
        <MUI.Stack gap={1} p={2} flex={1}>
          <MUI.Stack>
            <MUI.Typography
              component="div"
              display="flex"
              flexDirection="row"
              variant="body1"
              gap={1}
            >
              O usuário
              <MUI.Typography variant="body1" fontWeight="bold">
                {usuario.NOME}
              </MUI.Typography>{" "}
              está como
              <MUI.Typography variant="body1" fontWeight="bold">
                {usuario.DESCRICAO}
              </MUI.Typography>{" "}
            </MUI.Typography>
            <MUI.Typography variant="body2">
              Escolha o tipo de acesso:
            </MUI.Typography>
          </MUI.Stack>

          <MUI.Grid
            alignItems="center"
            width={["100%", "100%", "100%", "80%", "60%"]}
            container
            spacing={1}
          >
            <MUI.Grid item xs={12} md={3} sm={3}>
              <MUI.FormControl fullWidth>
                <MUI.Select
                  value={selectedOption}
                  onChange={handleSelectChange}
                  size="small"
                >
                  <MUI.MenuItem value="0">Básico</MUI.MenuItem>
                  <MUI.MenuItem value="1">Admin</MUI.MenuItem>
                  <MUI.MenuItem value="2">Master</MUI.MenuItem>
                </MUI.Select>
              </MUI.FormControl>
            </MUI.Grid>

            <MUI.Grid item xs={12} md={3} sm={3}>
              <MUI.Button
                fullWidth
                sx={{
                  backgroundColor: "#46B556",
                  color: "white",
                }}
                onClick={onSubmit}
              >
                {!loading ? "Atualizar" : "Atualizando"}
              </MUI.Button>
            </MUI.Grid>

            <MUI.Grid item xs={12} md={3} sm={3}>
              <MUI.Button
                fullWidth
                sx={{
                  backgroundColor: "#E13334",
                  color: "white",
                }}
                onClick={() => history.push("/gerenciamentodeusuario/listar")}
              >
                Cancelar
              </MUI.Button>
            </MUI.Grid>
          </MUI.Grid>
        </MUI.Stack>
      )}
    </MUI.Stack>
  );
};
